import * as API from '@/api';
import {getField, updateField} from 'vuex-map-fields';

function initialState () {
  return {
    list: {
      screeningWiseRevenue: [],
      filmWiseRevenue: [],
    },
  };
}

const state = initialState ();

// getters
const getters = {
  getField,
  list: state => {
    return state.list;
  },
};

// actions
const actions = {
  async listByScreenings (context, payload) {
    var response = await API.revenue.listByScreenings (payload);
    context.commit ('set_list', response);
    return response;
  },

  async listByFilms (context, payload) {
    var response = await API.revenue.listByFilms (payload);
    context.commit ('set_list', response);
    return response;
  },

  async list (context, payload) {
    var response = await API.revenue.list (payload);
    return response;
  },

  async getSummary (context, payload) {
    var response = await API.revenue.getSummary (payload);
    return response;
  },

  async requestPayout (context, payload) {
    var response = await API.revenue.requestPayout (payload);
    return response;
  },

};

// mutations
const mutations = {
  updateField,
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },

  set_list (state, payload) {
    if (payload.screening_wise_revenue) {
      state.list.screeningWiseRevenue = payload.screening_wise_revenue.data;
    }
    if (payload.film_wise_revenue) {
      state.list.filmWiseRevenue = payload.film_wise_revenue.data;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
